/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import http from "../http-common";
const controller = "/GithubActions";


const githubService = {
    async getanalyticsversion() {
        const response = await http.get(`${controller}/getanalyticsversion`);
        return await response.data;
    },
    async getanalyticsversions() {
        const response = await http.get(`${controller}/getanalyticsversions`);
        return await response.data;
    }
};
export default githubService;

